import { Component } from "projen";
import { AgentRule, AgentSkill, AgentSubAgent } from "../types";

/**
 * Renders agent configuration files for OpenAI Codex.
 *
 * Output files (future):
 * - AGENTS.md — root-level instructions
 * - `{dir}/AGENTS.md` — directory-scoped instructions
 *
 * TODO: Implement in a future issue.
 */
export class CodexRenderer {
  public static render(
    _component: Component,
    _rules: ReadonlyArray<AgentRule>,
    _skills: ReadonlyArray<AgentSkill>,
    _subAgents: ReadonlyArray<AgentSubAgent>,
  ): void {
    // Codex renderer is not yet implemented.
  }
}
